<template>
  <div class="row main-content">
    <div class="col">
      <h1 class="page-title font-custom text-uppercase mt-3">
        {{ $t('title.user.edition') }}
      </h1>

      <div
        v-if="isProcessing"
        class="text-center"
      >
        <img
          src="@/assets/img/loader.gif"
          class="mx-auto d-block center-block"
        >
      </div>

      <div v-else>
        <div
          v-if="responseErr"
          class="alert alert-danger text-center border-0 shadow-sm rounded-0"
        >
          <strong>
            {{ $t("error." + `${responseErr}`) }}
          </strong>
        </div>

        <div
          v-if="$store.state.users.user"
          id="accordion"
        >
          <div class="card rounded-0 mb-4">
            <div
              id="headingOne"
              data-bs-toggle="collapse"
              href="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
              class="card-header font-accent fw-bold"
            >
              Détails
            </div>
            <div
              id="collapseOne"
              aria-labelledby="headingOne"
              data-bs-parent="#accordion"
              class="card-body collapse show"
            >
              <div class="col">
                <label class="control-label fw-bold mb-1">
                  {{ $t('label.user.selectedIdentification') }}
                </label>
                <span
                  :title="$t('label.user.identificationFormat')"
                  data-bs-toggle="tooltip"
                  data-bs-placement="left"
                  class="label label-default ms-2"
                >
                  <i class="fa fa-question-circle fa-xs" />
                </span>
                <input
                  v-model="user.login"
                  :placeholder="$t('label.user.selectedIdentification')"
                  type="text"
                  class="form-control rounded-0"
                  disabled
                >
              </div>

              <div class="col mt-4">
                <label class="control-label fw-bold mb-1">
                  {{ $t('label.user.selectedEmail') }} *
                </label>
                <input
                  v-model="criterias.selectedEmail"
                  :class="status(v$.criterias.selectedEmail)"
                  :placeholder="$t('label.user.selectedEmail')"
                  type="text"
                  class="form-control rounded-0"
                >
                <p
                  v-if="validationError"
                  class="error"
                >
                  <span v-if="v$.criterias.selectedEmail.required.$invalid">{{ $t('error.MANDATORY_CRITERIA') }}</span>
                  <span v-else-if="v$.criterias.selectedEmail.$invalid">{{ $t('error.VALIDATION_FORMAT') }}</span>
                </p>
              </div>

              <div class="col mt-4">
                <label class="control-label fw-bold mb-1">
                  {{ $t('label.user.selectedEmailConfirmation') }} *
                </label>
                <input
                  v-model="criterias.selectedEmailConfirmation"
                  :class="status(v$.criterias.selectedEmailConfirmation)"
                  :placeholder="$t('label.user.selectedEmailConfirmation')"
                  type="text"
                  class="form-control rounded-0"
                >
                <p
                  v-if="validationError"
                  class="error"
                >
                  <span v-if="v$.criterias.selectedEmailConfirmation.required.$invalid">{{ $t('error.MANDATORY_CRITERIA') }}</span>
                  <span v-if="v$.criterias.selectedEmailConfirmation.emailConfirmed.$invalid">{{ $t('error.VALIDATION_EMAIL_CONFIRMATION') }}</span>
                  <span v-else-if="v$.criterias.selectedEmailConfirmation.$invalid">{{ $t('error.VALIDATION_FORMAT') }}</span>
                </p>
              </div>

              <div class="col mt-4">
                <label class="control-label fw-bold mb-1">
                  {{ $t('label.user.selectedDescription') }}
                </label>
                <span
                  :title="$t('label.user.descriptionFormat')"
                  data-bs-toggle="tooltip"
                  data-bs-placement="left"
                  class="label label-default ms-2"
                >
                  <i class="fa fa-question-circle fa-xs" />
                </span>
                <input
                  v-model="criterias.selectedDescription"
                  :class="status(v$.criterias.selectedDescription)"
                  :placeholder="$t('label.user.selectedDescription') "
                  type="text"
                  class="form-control rounded-0"
                >
                <p
                  v-if="validationError"
                  class="error"
                >
                  <span v-if="v$.criterias.selectedDescription.$invalid">{{ $t('error.VALIDATION_FORMAT') }}</span>
                </p>
              </div>

              <div class="col mt-4">
                <label class="control-label fw-bold mb-1">
                  {{ $t('label.user.selectedRole') }} *
                </label>
                <select
                  v-model="criterias.selectedRole"
                  name="role"
                  :class="status(v$.criterias.selectedRole)"
                  class="form-control rounded-0 form-select"
                  :data-placeholder="$t('label.user.selectedRole')"
                  :onchange="updateDistributer()"
                >
                  <option
                    value
                    selected
                    disabled
                    hidden
                  >
                    {{ $t('label.user.selectedRole') }}
                  </option>
                  <option
                    v-for="roleId in managedRoleIds"
                    :key="roleId.id"
                    :value="roleId"
                  >
                    {{ roleId }}
                  </option>
                </select>
                <p
                  v-if="validationError"
                  class="error"
                >
                  <span v-if="v$.criterias.selectedRole.required.$invalid">{{ $t('error.MANDATORY_CRITERIA') }}</span>
                </p>
              </div>

              <div class="col mt-4">
                <label class="control-label fw-bold mb-1">
                  {{ $t('label.user.selectedLanguage') }} *
                </label>
                <select
                  v-model="criterias.selectedLanguage"
                  name="langage"
                  :class="status(v$.criterias.selectedLanguage)"
                  class="form-control rounded-0 form-select"
                  :data-placeholder="$t('label.user.selectedLanguage')"
                >
                  <option
                    value
                    selected
                    disabled
                    hidden
                  >
                    {{ $t('label.user.selectedLanguage') }}
                  </option>
                  <option
                    v-for="lang in languages"
                    :key="lang.id"
                    :value="lang"
                  >
                    {{ lang }}
                  </option>
                </select>
                <p
                  v-if="validationError"
                  class="error"
                >
                  <span v-if="v$.criterias.selectedLanguage.required.$invalid">{{ $t('error.MANDATORY_CRITERIA') }}</span>
                </p>
              </div>

              <div
                v-show="showDistributor"
                class="col mt-4"
              >
                <label class="control-label fw-bold mb-1">
                  {{ $t('label.user.selectedDistributor') }} *
                </label>
                <span
                  :title="$t('label.user.distributorFormat')"
                  data-bs-toggle="tooltip"
                  data-bs-placement="left"
                  class="label label-default ms-2"
                >
                  <i class="fa fa-question-circle fa-xs" />
                </span>
                <select
                  v-model="criterias.selectedDistributor"
                  name="Distributeur"
                  :class="status(v$.criterias.selectedDistributor)"
                  class="form-control rounded-0 form-select"
                  :data-placeholder="$t('label.user.selectedDistributor')"
                >
                  <option
                    value
                    selected
                    disabled
                    hidden
                  >
                    {{ $t('label.user.selectedDistributor') }}
                  </option>
                  <option
                    v-for="distributorRef in distributorRefs"
                    :key="distributorRef.id"
                    :value="distributorRef"
                  >
                    {{ distributorRef }}
                  </option>
                </select>
                <p
                  v-if="validationError"
                  class="error"
                >
                  <span v-if="v$.criterias.selectedDistributor.requiredConditioned.$invalid">{{ $t('error.MANDATORY_CRITERIA') }}</span>
                </p>
              </div>

              <div class="col mt-4">
                <div class="form-check">
                  <input
                    id="internal"
                    v-model="criterias.selectedInternal"
                    name="internal"
                    :class="status(v$.criterias.selectedInternal)"
                    class="form-check-input"
                    type="checkbox"
                  >
                  <label
                    class="form-check-label fw-bold mb-1"
                    for="internal"
                  >
                    {{ $t('label.user.selectedInternal') }}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card card-body bg-light mb-4">
          <button
            type="button"
            class="btn btn-primary rounded-pill font-custom font-inverted btn-export"
            @click="editUser()"
          >
            {{ $t("button.save") }}
          </button>
        </div>
      </div>
    </div>

    <!-- Success Modal -->
    <div
      id="successModal"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="successModalLabel"
      aria-hidden="true"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
    >
      <div
        class="modal-dialog"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5
              id="successModalLabel"
              class="modal-title"
            >
              {{ $t('label.modal.SUCCESS_MODAL_LABEL') }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="leavePage()"
            />
          </div>
          <div class="modal-body">
            <div class="alert alert-success">
              <p id="successModalMsg" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Error Modal -->
    <div
      id="errorModal"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="errorModalLabel"
      aria-hidden="true"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
    >
      <div
        class="modal-dialog"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5
              id="errorModalLabel"
              class="modal-title"
            >
              {{ $t('label.modal.ERROR_MODAL_LABEL') }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="leavePage()"
            />
          </div>
          <div class="modal-body">
            <div class="alert alert-danger">
              <p id="errorModalMsg" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script src="./UserEdit.js"></script>

<style src="./UserEdit.scss" scoped lang="scss"></style>
